const isEmpty = require("is-empty");
const initialState = {
    isAuthenticated: false,
    loanvalue: {},
    loading: false
};
export default function(state = initialState, action) {
    switch (action.type) {

        case 'LOANTOVALUE_ADD':
        return {
                isAuthenticated: !isEmpty(action.payload),
                loanvalue: action.payload
        };

        case 'LOANTOVALUE_UPDATE':
            return {
                isAuthenticated: !isEmpty(action.payload),
                loanvalue: action.payload,
            };
        case 'SET_CURRENT_LOANTOVALUE':
            return {
                ...state,
                isAuthenticated: !isEmpty(action.payload),
                loanvalue: action.payload
            };

        case 'LOANTOVALUE_LOADING':
            return {
                ...state,
                loading: true
            };
        default:
            return state;
    }
}